import { z } from 'zod';
/**
 * Ошибка выбора при создании персонажа.
 *
 * Обязателен слот: «выбор недопустим» без указания, какой именно, —
 * это отказ без объяснения, и чинить его человек будет наугад.
 * Код — для интерфейса (подпись собирается через i18next, D11),
 * сообщение — готовый русский текст для тех, кто читает ответ глазами.
 */
export const creationProblemCodeSchema = z.enum([
    /** Слота с таким ключом в плане нет. */
    'unknown-slot',
    /** Значения нет среди вариантов слота. */
    'unknown-option',
    /** Выбрано не столько вариантов, сколько требует слот. */
    'wrong-count',
    /** Один и тот же вариант выбран дважды. */
    'duplicate-pick',
    /** Записи контента с таким ключом нет среди переданных. */
    'unknown-content',
    /** Набор значений не совпадает со стандартным. */
    'not-standard-array',
    /** Покупка вышла за бюджет очков. */
    'point-buy-over-budget',
    /** Значение нельзя купить: его нет в таблице стоимости. */
    'score-not-purchasable',
    /** Брошенное значение вне диапазона, который даёт бросок. */
    'roll-out-of-range',
    /** Брошено не столько значений, сколько требует правило. */
    'wrong-roll-count',
    /** Назначены не те числа, которые были получены. */
    'assignment-mismatch',
    /** Раскладка прибавок не совпадает ни с одной разрешённой. */
    'increase-pattern',
    /** Прибавка идёт в характеристику, которой предыстория не даёт. */
    'increase-not-offered',
    /** Прибавка поднимает характеристику выше предела. */
    'increase-over-max',
    /** Класс меняется правкой только на первом уровне (D62). */
    'class-locked',
    /** После правки создания не собираются шаги повышений (D62). */
    'levels-broken',
    /** Владение уже есть: от записи или из другого слота (D63). */
    'already-proficient',
]);
export const creationProblemSchema = z.strictObject({
    /** Слот, к которому относится ошибка: `class.skills`, `abilities`. */
    slot: z.string().min(1),
    code: creationProblemCodeSchema,
    message: z.string().min(1),
});
//# sourceMappingURL=problems.js.map